export class ErrorData {
	public static create(options: ErrorDataOptions): ErrorData {
		return new ErrorData(options.id, options.success, options.allDataReturned, options.errorCodes, options.failureReason, options.debugMessage);
	}
	constructor(
		public readonly id: string,
		public readonly success: boolean,
		public readonly allDataReturned: boolean,
		public readonly errorCodes: Array<string>,
		public readonly failureReason: string,
		public readonly debugMessage: string,
		public hideOnError: boolean = false
	) {}
}

export interface ErrorDataOptions {
	id: string;
	success: boolean;
	allDataReturned: boolean;
	errorCodes: Array<string>;
	failureReason: string;
	debugMessage: string;
	hideOnError: boolean;
}
